import { Component, Input, OnDestroy } from '@angular/core';
import { OnInit } from '@angular/core';
import * as moment from 'moment';
import { AddBatchDialogComponent } from "../add-batch/add-batch-dialog.component";
import { ExpiryReportService } from '../../services/expiry-report.services';
import { MatDialog } from '@angular/material';
import { MedicineDetailComponent } from '../medicine-detail/medicine-detail.component';
import { IncidentsDialogComponent } from '../incidents-dialog/incidents-dialog.component';
import { BatchDialogComponent } from '../batch-dialog/batch-dialog.component';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { EventBusService } from 'src/services/event-bus.service';
import { AlertComponent } from '../alert/alert.component';

@Component({
  selector: 'rm-expiry-report',
  templateUrl: './expiry-report.component.html',
  styleUrls: ['./expiry-report.component.css']
})
export class ExpiryReportComponent implements OnInit, OnDestroy {

  @Input()
  productId: string;

  @Input()
  gcp: string;

  dateRange: string = 'all';
  fromDtm: any = null;
  toDtm: any = null;
  expiryData: any[] = [];

  //Used for pagination
  bookmark: string = "";
  totalCount: number = 0;
  pageSize: number = 5;
  skip: number = 0;
  columns: any[];
  bookmarks: any = [];
  labels: any;
  subscriptions: any[] = [];

  constructor(
    private expiryreportService: ExpiryReportService,
    private dialog: MatDialog,
    private globalCfgService: GlobalCfgService,
    private ebService: EventBusService
  ) { }

  ngOnInit() {
    this.loadExpiryData();

    this.subscriptions.push(this.ebService.particpantSelectionFetchedValue$.subscribe(
      (gcp) => {
        this.gcp = gcp;
        this.loadExpiryData();
      }
    ));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  loadExpiryData(page?, fromDt?, toDt?) {
    if (!this.gcp) {
      this.gcp = this.globalCfgService.getGcp();
    }

    var obj = {};

    if (this.gcp) {
      obj['gcp'] = this.gcp;
    }

    if (this.productId) {
      obj['gtin'] = this.productId;
    }
    obj['pageSize'] = (page && page.pageSize) || this.pageSize;

    if (page) {
      this.skip = page.pageIndex * this.pageSize;
      obj['skip'] = this.skip;
    } else if (page === undefined) {
      obj['skip'] = this.skip;
    }

    if (fromDt) {
      obj['fromDate'] = fromDt;
    }

    if (toDt) {
      obj['toDate'] = toDt;
    }

    this.labels = this.globalCfgService.getSettingValue('labels');
    this.columns = [
      { name: 'img', displayName: '', type: 'image' },
      { name: 'name', displayName: this.labels['medicine'], actionable: true },
      { name: 'gtin', displayName: this.labels['gtin'], actionable: true },
      { name: 'batchNo', displayName: 'Batch No.', actionable: true },
      { name: 'expiryDt', displayName: 'Expiry Date', type: 'date', format: 'DD/MM/YYYY' },
      { name: 'location', displayName: this.labels['mfg_location'] },
      { name: 'viewOnMap', displayName: '', actionable: true, actionableIcon: 'map', tip: 'View Distribution' }
    ];


    this.expiryreportService.expiryReport(obj).subscribe(
      (response) => {
        if (page && page.pageIndex) {
          this.bookmarks[page.pageIndex + 1] = response['metadata'].bookmark;
        } else {
          this.bookmarks[1] = response['metadata'].bookmark;
        }
        this.totalCount = response['metadata'].totalCount;

        this.expiryData = Object(response['result']);
      });
  }

  onSelectionChange(eventValue) {
    this.gcp = this.globalCfgService.getGcp();
    if (!this.gcp) {
      this.dateRange = 'All';
      const dialogRef = this.dialog.open(AlertComponent, {
        width: "450px",
        data: {
          title: "Select Organisation",
          note: "Select an organisation and try again",
        },
      });

      return;
    }
    this.loadExpiryReportByDateRange();
  }


  loadExpiryReportByDateRange() {
    this.skip = 0;
    this.fromDtm = null;
    this.toDtm = null;
    var presentation;
    if (this.dateRange == '7days') {
      this.toDtm = moment().add(7, 'days').hour(0).minute(0).second(0).millisecond(0).format("YYYY/MM/DD");
      this.fromDtm = moment().format("YYYY/MM/DD");
      presentation = 'date';
    }

    if (this.dateRange == '2weeks') {
      this.toDtm = moment().add(14, 'days').hour(0).minute(0).second(0).millisecond(0).format("YYYY/MM/DD");
      this.fromDtm = moment().format("YYYY/MM/DD");
      presentation = 'date';
    }

    if (this.dateRange == '1month') {
      this.toDtm = moment().add(1, 'month').hour(0).minute(0).second(0).millisecond(0).format("YYYY/MM/DD");
      this.fromDtm = moment().format("YYYY/MM/DD");
      presentation = 'week';
    }

    if (this.dateRange == '6months') {
      this.toDtm = moment().add(6, 'months').hour(0).minute(0).second(0).millisecond(0).format("YYYY/MM/DD");
      this.fromDtm = moment().format("YYYY/MM/DD");
      presentation = 'month';
    }

    if (this.dateRange == '12months') {
      this.toDtm = moment().add(12, 'months').hour(0).minute(0).second(0).millisecond(0).format("YYYY/MM/DD");
      this.fromDtm = moment().format("YYYY/MM/DD");
      presentation = 'month';
    }

    if (this.dateRange == '18months') {
      this.toDtm = moment().add(18, 'months').hour(0).minute(0).second(0).millisecond(0).format("YYYY/MM/DD");
      this.fromDtm = moment().format("YYYY/MM/DD");
      presentation = 'month';
    }

    if (this.dateRange == '24months') {
      this.toDtm = moment().add(24, 'months').hour(0).minute(0).second(0).millisecond(0).format("YYYY/MM/DD");
      this.fromDtm = moment().format("YYYY/MM/DD");
      presentation = 'month';
    }

    if (this.dateRange == '36months') {
      this.toDtm = moment().add(36, 'months').hour(0).minute(0).second(0).millisecond(0).format("YYYY/MM/DD");
      this.fromDtm = moment().format("YYYY/MM/DD");
      presentation = 'month';
    }


    this.loadExpiryData(null, this.fromDtm, this.toDtm);
  }

  onActionableClicked(e) {
    console.log('onActionableClicked:', e);

    var rec = e.record;
    switch (e.actionName) {
      case 'gtin':
      case 'name':
        this.dialog.open(MedicineDetailComponent, {
          width: '2400px',
          data: { medicineId: rec.gtin }
        });
        break;
      case 'batchNo':
        this.dialog.open(AddBatchDialogComponent, {
          width: "2400px",
          data: {
            rec: rec,
            title: 'Batch Detail'
          }

        });
        break;
      case 'viewOnMap':
        this.dialog.open(IncidentsDialogComponent, {
          width: '2400px',
          data: {
            title: "Distribution",
            batchNum: rec.batchNo,
            gcp: this.globalCfgService.getGcp()
          }
        });
        break;
      default:
        console.log('Unhandled actionable: ', e.actionName);
    }

  }

  onPageChanged(page) {
    this.pageSize = page.pageSize;
    if (this.fromDtm && this.toDtm) {
      this.loadExpiryData(page, this.fromDtm, this.toDtm);
    } else {
      this.loadExpiryData(page);
    }

  }

}